import React, { useState, useEffect } from "react";
import { CardHeader, CardContent, CardActions } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import AddUserToFolderInfo from "../../../components/Advertisements/AddUserToFolder/AddUserToFolderInfo";
import EngineeringIcon from "@mui/icons-material/Engineering";
import AdvertisementService from "../../../../services/advertisements";
import { Modal } from "antd";
import { Toast } from "../../../../utils/alerts";
import { CODES } from "../../../../utils/responseCodes";

const AddUserToFolder = (props) => {
  const { open, handleClose, setTitleModalLoader, setOpenModalLoader, getAdvertisements, infoAdvertisement,carpetaSeleccionada } = props;
  
  const [usuarioLA, setUsuarioLA] = useState(null);
  const [infoUsuarioLA, setInfoUsuarioLA] = useState(null);
  const [usuarioCarpeta, setUsuarioCarpeta] = useState(null);
  const [usuariosAgregados, setUsuariosAgregados] = useState([]);

  const cleanInfo = () => {
    handleClose();
    setInfoUsuarioLA(null);
    setUsuariosAgregados([]);
  };
  useEffect(() => {
    if (open && carpetaSeleccionada) {
      getUsersByCarpeta();
    }
  }, [open, carpetaSeleccionada]);


  const getUsersByCarpeta = async () => {
    try {
      setOpenModalLoader(true);
      const result = await AdvertisementService.getUsersByCarpeta({
        carpetaArea_id: carpetaSeleccionada,
      });

        if (result.status === CODES.SUCCESS_200) {
            setUsuarioCarpeta(result.data);
        }

        setOpenModalLoader(false);

    } catch (error) {
        console.log(`Error en getUsersByCarpeta: ${error}`);
    }
};


  const saveUsersByCarpeta = async (e) => {
    e.preventDefault();
    setOpenModalLoader(true);
   // setTitleModalLoader("Compartiendo ...");

    const formData = new FormData();
    formData.append("carpetaArea_id", carpetaSeleccionada);

    usuariosAgregados.forEach((usuario) => {
      formData.append("usuario_ids[]", usuario.value); // .value es el ID
    });

    try {
      const response = await AdvertisementService.saveUsersByCarpeta(formData);

      if (response.status === 201) {
        Toast.fire({
          icon: "success",
          title: response.data.message || "Usuarios asignados",
        });
      } else {
        Toast.fire({
          icon: "error",
          title: "Error al compartir la carpeta.",
        });
      }
    } catch (error) {
      console.error(error);
      Toast.fire({
        icon: "error",
        title: "Ocurrió un error inesperado.",
      });
    } finally {
      setOpenModalLoader(false);
      getUsersByCarpeta();
      setInfoUsuarioLA(null);
      setUsuariosAgregados([]);
    //  setTitleModalLoader("");
    }
  };

  return (
    <Modal
      title={
        <CardHeader
          avatar={
            <Avatar
              sx={{ bgcolor: "#13005A", fontSize: "xx-small" }}
              aria-label="recipe"
            >
              <EngineeringIcon />
            </Avatar>
          }
          title={"Datos del Usuario"}
          subheader={"Informacion complementaria"}
          sx={{
            paddingBottom: "0.3rem",
            paddingTop: 0,
            margin: "-0.5rem -1rem -0.1rem -1rem",
            borderBottom: `solid 0.05rem #D5DBDB`,
          }}
        />
      }
      open={open}
      onOk={cleanInfo}
      onCancel={cleanInfo}
      destroyOnClose={true}
      footer={null}
      style={{ top: "10%" }}
      width={800}
    >
      <form onSubmit={saveUsersByCarpeta}>
        <CardContent sx={{ padding: 0, margin: "0 -0.5rem" }}>
          <AddUserToFolderInfo
            carpetaSeleccionada={carpetaSeleccionada}
            usuarioLA={usuarioLA} setUsuarioLA={setUsuarioLA}
            infoUsuarioLA={infoUsuarioLA} setInfoUsuarioLA={setInfoUsuarioLA}
            usuarioCarpeta={usuarioCarpeta} setUsuarioCarpeta={setUsuarioCarpeta}
            usuariosAgregados={usuariosAgregados}
            setUsuariosAgregados={setUsuariosAgregados}
            getUsersByCarpeta={getUsersByCarpeta}
         
          />
        </CardContent>

        <CardActions
          sx={{
            //paddingBottom: '0.3rem',
            //paddingTop: 0,
            margin: "0.5rem -1rem -1rem -1rem",
            borderTop: `solid 0.05rem #00337C`,
          }}
        >
          <button
            type={"submit"}
            className="btn btn-outline-primary btn-sm"
            style={{ fontSize: "15px" }}
          >
            Compartir
          </button>
          <button
            type={"button"}
            onClick={cleanInfo}
            className="btn btn-outline-danger btn-sm"
            style={{ fontSize: "15px" }}
          >
            Cerrar
          </button>
        </CardActions>
      </form>
    </Modal>
  );
};

export default AddUserToFolder;
